import * as signalR from '@microsoft/signalr';
import config from '../config';

let connection = null;
let connectionPromise = null;
let tokenAtBuild = null;

const getRawToken = () => {
    const t = localStorage.getItem('JWToken');
    if (!t) return null;
    return t.replace(/^Bearer\s+/i, '').trim();
};

export const getChatConnection = async () => {
    const token = getRawToken();
    if (!token) throw new Error('Missing token');

    if (connection && connection.state === signalR.HubConnectionState.Connected) {
        if (tokenAtBuild === token) return connection;

        try { await connection.stop(); } catch {}
        connection = null;
        tokenAtBuild = null;
    }

    if (connectionPromise) {
        return await connectionPromise;
    }

    connectionPromise = (async () => {
        const currentToken = getRawToken();
        if (!currentToken) throw new Error('Missing token');

        if (connection) {
            try { await connection.stop(); } catch {}
        }

        connection = new signalR.HubConnectionBuilder()
            .withUrl(`${config.SERVER.BASE_URL}${config.SERVER.CHAT_HUB_PATH}`, {
                accessTokenFactory: () => getRawToken() ?? '',
                withCredentials: false
            })
            .withAutomaticReconnect()
            .build();

        connection.onclose(() => {
            connectionPromise = null;
            tokenAtBuild = null;
        });

        await connection.start();

        tokenAtBuild = currentToken;
        connectionPromise = null;
        return connection;
    })();

    return await connectionPromise;
};

export const joinLobby = async (lobbyId) => {
    const conn = await getChatConnection();
    await conn.invoke('JoinLobby', lobbyId);
};

export const leaveLobby = async (lobbyId) => {
    const conn = await getChatConnection();
    await conn.invoke('LeaveLobby', lobbyId);
};